export default from './NotFound';



// WEBPACK FOOTER //
// ./src/views/NotFound/index.js